module.exports = __webpack_public_path__ + "img/remove-question-option.e9acd51c.svg";